<script lang="ts">
  import LookupGrid from "../components/content/lookup/LookupGrid.svelte";
  import LookupDrawer from "../components/drawers/LookupDrawer.svelte";
</script>

<div class="component-container">
  <div class="component-content app-grid inside-object">
    <LookupGrid />
    <LookupDrawer />
  </div>
</div>
